import { Container, Grid } from '@mui/material';
import React from 'react';
import PaymentableItemShow from './PaymentableItemShow';

const PaymentableItemList = () => {
  return (
    <>
      <Container sx={{ mt: 4 }} maxWidth='xl'>
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='stretch'
          spacing={3}>
          <Grid item xs={12}>
            <PaymentableItemShow />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PaymentableItemList;
